import React, { Component } from "react";
import { Container, Button, Modal, Row, Col, Tooltip, OverlayTrigger } from "react-bootstrap";
import { getParameterFromManager } from 'services/Utils';
import { Auth } from "aws-amplify";
import { invokeLambdaWithRetry } from "services/Helper";
import config from 'aws-exports';
import { createUiLogger } from "../../../logging/uiLogger";
const console = createUiLogger("meaplatform/classic/components/Footer/Footer.js");



class Footer extends Component {
  constructor(props){
    super(props);
    this.state={ showModal: false, showModalMsg: {
      instanceName: "",
      instanceType: "",
      instanceRegion: "",
      releaseNumber: "",
      buildNumber: ""
    },
    profileInfo: {
      enabled: false,
      activeProfileName: ""
    }}
  }

  async componentDidMount() {
    await this.loadProfileInfo();
  }

  async loadProfileInfo() {
    try {
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
      const result = await invokeLambdaWithRetry("instanceHandler", {
        body: JSON.stringify({
          access_token: user.signInUserSession.idToken.jwtToken,
          target: "get-app-profile-state"
        })
      });
      this.setState((prevState) => ({
        ...prevState,
        profileInfo: {
          enabled: result?.response?.enabled === true,
          activeProfileName: result?.response?.activeProfileName || ""
        }
      }));
    } catch (error) {
      console.debug(error);
    }
  }

  async getBuildInfo() {
    try {
        return await Promise.all([
          await getParameterFromManager(`MEAPLATFORM_BUILD_VERSION`),
          await getParameterFromManager(`MEAPLATFORM_RELEASE_VERSION`),
          await getParameterFromManager(`ENVIRONMENT_DETAILS`)
        ])
    } catch (e) {
      console.debug(e);
    }
  }

  async handleGetBuildInfo() {
    this.setState(prevState =>  ({...prevState, showModal: true}))
    if (this.state.showModalMsg?.instanceName && this.state.showModalMsg?.instanceType && this.state.showModalMsg?.instanceRegion && this.state.showModalMsg?.releaseNumber && this.state.showModalMsg?.buildNumber) return;
    const [buildVersion, releaseVersion, envDetails] = await this.getBuildInfo();
    this.setState(prevState =>  ({...prevState, showModalMsg: {
      instanceName: envDetails?.instance_name,
      instanceType: envDetails?.instance_type,
      instanceRegion: config.aws_project_region,
      releaseNumber: releaseVersion,
      buildNumber: buildVersion
    }}))
  }

  render() {
    return (
      <footer className="footer pt-2 pb-2 pl-3 pr-3">
        <Container fluid>
          <nav>
            <ul className="footer-menu">
              <li>
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  Home
                </a>
              </li>
              <li className="footer-separator">{" "}|{" "}</li>
              <li>
                <a href={window.location.href} onClick={(e) => {
                  e.preventDefault();
                  this.handleGetBuildInfo();
                }}>build info</a>
              </li>
              {this.state.profileInfo.enabled ? (
                <>
                  <li className="footer-separator">{" "}|{" "}</li>
                  <li>
                    <span>profile: {this.state.profileInfo.activeProfileName || "Default"}</span>
                  </li>
                </>
              ) : null}
            </ul>
            <p className="copyright text-center">
              © {new Date().getFullYear()}{" "}
              mea platform
            </p>
          </nav>
        </Container>
        <Modal
          className="modal-md modal-primary"
          size="lg"
          show={this.state.showModal}
          onHide={() => this.setState(prevState =>  ({...prevState, showModal: false}))}
          animation={false}
        >
          <Modal.Body className="pb-xl-0">
            <Container>
              <Row>
                <Col className="mb-3" sm={4}>
                  <div className="font-weight-bold">Instance Name</div>
                  <div>{this.state.showModalMsg.instanceName}</div>
                </Col>
                <Col className="mb-3" sm={4}>
                  <div className="font-weight-bold">Instance Type</div>
                  <div>{this.state.showModalMsg.instanceType}</div>
                </Col>
                <Col className="mb-3" sm={4}>
                  <div className="font-weight-bold">Instance Region</div>
                  <div>{this.state.showModalMsg.instanceRegion}</div>
                </Col>
              </Row>
              <Row>
                <Col className="mb-3" sm={4}>
                  <div className="font-weight-bold">Release Number</div>
                  <div>{this.state.showModalMsg.releaseNumber}</div>
                </Col>
                <Col sm={8}>
                  <div className="font-weight-bold">Build Number</div>
                  <OverlayTrigger overlay={<Tooltip>{this.state.showModalMsg.buildNumber}</Tooltip>} placement="bottom">
                    <span className="d-inline-block">
                      <div className="build-info-truncated">{this.state.showModalMsg.buildNumber}</div>
                    </span>
                  </OverlayTrigger>
                </Col>
              </Row>
            </Container>
            <hr />
          </Modal.Body>
          <div className="modal-footer">
            <Button
              className="btn-simple"
              type="button"
              variant="link"
              onClick={() => this.setState(prevState =>  ({...prevState, showModal: false}))}
            >
              Close
            </Button>
          </div>
        </Modal>
      </footer>
    );
  }
}

export default Footer;
